export default __webpack_public_path__ + "static/media/success.85f6c088.mp3";